export enum WalletType {
  SOLANA,
  APTOS,
  MOVEMENT,
  MONAD
}